// 法人证件类型枚举
export const corporateType = {
  0: '身份证',
  1: '港澳回乡证',
  2: '台胞证',
  3: '外国护照'
}
// 服务状态枚举
export const serviceState = {
  0: '停用',
  1: '启用',
  2: '开户中',
  3: '开户失败'
}
